import { getDeterministicHashByString } from 'src/utils/getDeterministicHashByString'

const MIN_FAVORITES = 124
const MAX_FAVORITES = 2500
const RANGE_SIZE = MAX_FAVORITES - MIN_FAVORITES + 1

export const getDeterministicFavoritesByProductId = (
  productId?: string | number
): number => {
  const normalizedProductId = String(productId ?? '').trim()

  if (!normalizedProductId) {
    return MIN_FAVORITES
  }

  const hash = getDeterministicHashByString(normalizedProductId)

  return MIN_FAVORITES + (hash % RANGE_SIZE)
}

export const formatCompactFavoritesCount = (value: number): string => {
  if (value >= 1000) {
    const compactValue = Math.round((value / 1000) * 10) / 10

    return `${compactValue.toFixed(1)}K`
  }

  return String(value)
}

export const formatFullFavoritesCount = (value: number): string => {
  return new Intl.NumberFormat('pt-BR').format(value)
}
